// Product pages: the header bag opens the cart drawer instead of loading the cart page,
// and the bag count stays in sync after adding or changing items.
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cart-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    var drawer = getDrawer();
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(link);
  });

  function updateBagCount(count) {
    document.querySelectorAll('[data-cart-link]').forEach(function (link) {
      var badge = link.querySelector('.at-bag-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'at-bag-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number') {
        updateBagCount(data.item_count);
        return;
      }
      fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { updateBagCount(cart.item_count); })
        .catch(function () {});
    });
  }
})();
